export interface DeviceInfo {
  deviceType: string;
  browser: string;
  browserVersion: string;
  operatingSystem: string;
  screenResolution: string;
  userAgent: string;
}

export function getDeviceInfo(): DeviceInfo {
  const userAgent = navigator.userAgent;
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  
  // Device type detection
  let deviceType = 'Desktop';
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      deviceType = /iPad/i.test(userAgent) ? 'iPad' : 'iPhone';
    } else if (/Android/i.test(userAgent)) {
      deviceType = 'Android';
    } else {
      deviceType = 'Mobile';
    }
  } else if (/Tablet|iPad/i.test(userAgent)) {
    deviceType = 'Tablet';
  }
  
  // Browser detection
  let browser = 'Unknown';
  let browserVersion = 'Unknown';
  
  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    browser = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Firefox')) {
    browser = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browser = 'Safari';
    const match = userAgent.match(/Version\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Edg')) {
    browser = 'Edge';
    const match = userAgent.match(/Edg\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) {
    browser = 'Internet Explorer';
    const match = userAgent.match(/MSIE (\d+)/) || userAgent.match(/rv:(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  }
  
  // Operating system detection
  let operatingSystem = 'Unknown';
  if (userAgent.includes('Windows')) {
    operatingSystem = 'Windows';
  } else if (userAgent.includes('Mac OS X')) {
    operatingSystem = 'macOS';
  } else if (userAgent.includes('Linux')) {
    operatingSystem = 'Linux';
  } else if (userAgent.includes('Android')) {
    operatingSystem = 'Android';
  } else if (userAgent.includes('iOS')) {
    operatingSystem = 'iOS';
  }
  
  return {
    deviceType,
    browser,
    browserVersion,
    operatingSystem,
    screenResolution: `${screenWidth}x${screenHeight}`,
    userAgent
  };
}

export function formatDeviceInfo(info: DeviceInfo): string {
  return `${info.deviceType} - ${info.browser} ${info.browserVersion} on ${info.operatingSystem}`;
} 